var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("modal", {
        staticClass: "modal-wrapper",
        attrs: { width: _vm.width, height: _vm.height, hideClose: true },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "px-2 py-1 w-full" }, [
                  _c("div", { staticClass: "w-full" }, [
                    _vm.currentStepData
                      ? _c(
                          "div",
                          [
                            _vm.currentStepData.formTitle
                              ? _c("IntakeForm", {
                                  attrs: {
                                    steps: _vm.formatFormSteps(
                                      _vm.currentStepData.questions
                                    ),
                                    showButton: true,
                                    fieldsToMonitor: _vm.fieldsToMonitor(
                                      _vm.currentStepData.questions
                                    ),
                                    buttonText: "Submit",
                                    exitButtonText: "Continue Browsing",
                                  },
                                  on: {
                                    "hide-modal": function ($event) {
                                      return _vm.hideModal()
                                    },
                                    progress: function ($event) {
                                      return _vm.progress()
                                    },
                                    submitHandler: (value) => {
                                      _vm.submitAnonymousLargeFleetLead(value)
                                      _vm.anonymousLeadSubmissionTracking(
                                        "mini-pricing-form"
                                      )
                                      _vm.setInquiryModalSubmitted(true)
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "content",
                                        fn: function () {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-center space-bottom-1",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-2xl font-bold",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.currentStepData
                                                          .formHeader
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "text-base" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.currentStepData
                                                          .formSubHeader
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    1282890739
                                  ),
                                })
                              : _c(_vm.getComponent, {
                                  tag: "Component",
                                  attrs: {
                                    step: _vm.currentStepData,
                                    showButton: true,
                                  },
                                  on: {
                                    progress: function ($event) {
                                      return _vm.progress()
                                    },
                                    back: function ($event) {
                                      return _vm.back()
                                    },
                                    "hide-modal": function ($event) {
                                      return _vm.hideModal()
                                    },
                                    anonymousMonitoringSegment:
                                      _vm.setSizingSegment,
                                    fleetSize: _vm.fleetSizeHandler,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "header-content",
                                        fn: function () {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-center space-bottom-1",
                                              },
                                              [
                                                _vm.currentStepData.title
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-2xl font-bold header-style",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.currentStepData
                                                              .title
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.currentStepData.subTitle
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-base subheader-style",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.currentStepData
                                                              .subTitle
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "body-content",
                                        fn: function () {
                                          return [
                                            _vm.currentStepData.bodyHeader
                                              ? _c(
                                                  "div",
                                                  { staticClass: "font-bold" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.currentStepData
                                                          .bodyHeader
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.currentStepData.bodySubHeader
                                              ? _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.currentStepData
                                                        .bodySubHeader
                                                    )
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.currentStepData.bodyText
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-center text-base",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.currentStepData
                                                          .bodyText
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "disclaimer",
                                        fn: function () {
                                          return [
                                            _vm.currentStepData.bodyDisclaimer
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "align-center",
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      { staticClass: "italic" },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.currentStepData
                                                              .bodyDisclaimer
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "login",
                                        fn: function () {
                                          return [
                                            _vm.currentStepData.login
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "align-center",
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "text-center",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Already a customer? "
                                                        ),
                                                        _c(
                                                          "a",
                                                          {
                                                            staticClass:
                                                              "text-blue-600",
                                                            attrs: {
                                                              href: "https://cloud.samsara.com/webstore",
                                                            },
                                                          },
                                                          [_vm._v("Login")]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    4119765058
                                  ),
                                }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }